import { withTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import BootstrapModal from "react-bootstrap/Modal";
import Image from "next/image";
import Button from "@components/core/Button";
import ImgixLoader from "@utils/images/ImgixLoader";
import classNames from "classnames";
import ProductZoomImage from "./ProductZoomImage";

function ProductZoomModal({
  show,
  close,
  pictures,
  indexStart = 0,
  t,
}) {
  const [mostVisiblePictureIndex, setMostVisiblePictureIndex] = useState(0);

  function scrollToSelectedPicture(index) {
    const selectedPicture = document.getElementById(`product-zoom-image-container-${index}`);

    if (selectedPicture) selectedPicture.scrollIntoView({ behavior: "smooth" });
  }

  useEffect(() => {
    function scrollToStartingPicture(imgIndex) {
      const startingPicture = document.getElementById(`product-zoom-image-container-${imgIndex}`);

      if (startingPicture) startingPicture.scrollIntoView({ behavior: "instant" });
    }

    if (show) scrollToStartingPicture(indexStart);
  }, [show, indexStart]);

  return (
    <BootstrapModal
      show={show}
      onHide={close}
      fullscreen={true}
    >
      <div className="product-zoom-modal">
        <div className="product-zoom-modal-body" onClick={close}>
          {pictures.map((picture, index) => (
            <ProductZoomImage
              imgUrl={picture.large_url}
              setMostVisiblePictureIndex={setMostVisiblePictureIndex}
              index={index}
              key={picture.id}
            />
          ))}
        </div>

        <Button
          onClick={close}
          variant="ghost-dark"
          leftIconName="close"
          className="d-lg-none product-zoom-close-btn"
        />
        <Button
          onClick={close}
          variant="ghost-dark"
          rightIconName="close"
          hugContent
          className="d-none d-lg-block product-zoom-close-btn"
        >
          {t("product:zoom_modal_close_btn")}
        </Button>

        <div className="zoom-picker">
          {pictures.map((picture, index) => (
            <div
              key={picture.id}
              className={classNames("zoom-picker-image-container", index === mostVisiblePictureIndex && "active")}
              onClick={() => scrollToSelectedPicture(index)}
            >
              <Image
                loader={ImgixLoader}
                src={picture.large_url}
                alt=""
                fill
                className="zoom-picker-image"
                sizes="128px"
              />
            </div>
          ))}
        </div>
      </div>
    </BootstrapModal>
  );
}

export default withTranslation("product")(ProductZoomModal);
